import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const EmailList = () => {
  const [emails, setEmails] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false); // Track bulk email sending status

  // Fetch emails from the backend when the component mounts
  useEffect(() => {
    const fetchEmails = async () => {
      setLoading(true);
      setError(null); // Reset any previous error state
      try {
        console.log("Fetching emails from:", "/api/emails");
        const res = await axios.get("/api/emails"); // Request emails from your backend
        console.log(res); // Log the response to inspect its structure
    
        // Check if the response is an array
        if (Array.isArray(res.data)) {
          setEmails(res.data); // Set fetched emails into state
        } else {
          console.error("Expected an array, but received:", res.data);
          setEmails([]); // Handle error by resetting emails to empty
          setError("Failed to fetch emails. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching emails:", error); // Log errors
        setEmails([]); // Reset emails in case of error
        setError("An error occurred while fetching emails. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    

    fetchEmails(); // Call fetch emails on component mount
  }, []);

  // Handle selecting/deselecting emails
  const toggleSelect = useCallback((email) => {
    setSelectedEmails((prevSelectedEmails) => {
      if (prevSelectedEmails.includes(email)) {
        return prevSelectedEmails.filter(e => e !== email);
      } else {
        return [...prevSelectedEmails, email];
      }
    });
  }, []);

  // Handle selecting/deselecting all emails
  const toggleSelectAll = () => {
    if (selectedEmails.length === emails.length) {
      setSelectedEmails([]); // Deselect all
    } else {
      setSelectedEmails(emails.map(email => email.email)); // Select all
    }
  };

  // Handle sending bulk email
  const handleSendBulkEmail = async () => {
    if (selectedEmails.length === 0) {
      alert("Please select at least one email!"); // Alert if no email is selected
      return;
    }

    setSending(true); // Set sending state to true while sending bulk email

    try {
      const payload = {
        emails: selectedEmails, // Selected emails
        subject: "Bulk Email Subject", // Customize subject
        content: "<p>This is the email content</p>", // Customize email content
      };

      const res = await axios.post("/api/emails/send-bulk", payload); // Send bulk email to backend
      alert("✅ Bulk email sent successfully!");
      setSelectedEmails([]); // Reset selected emails
    } catch (error) {
      console.error(error);
      alert("❌ Failed to send bulk emails.");
    } finally {
      setSending(false); // Reset sending state once finished
    }
  };

  return (
    <div>
      <h2>Brevo Email List</h2>

      {error && <p style={{ color: "red" }}>{error}</p>} {/* Display error message */}

      <button
        onClick={handleSendBulkEmail}
        disabled={selectedEmails.length === 0 || sending} // Disable when sending
      >
        {sending ? "Sending..." : "Send Bulk Email"}
      </button>

      <div>
        <label>
          <input
            type="checkbox"
            checked={selectedEmails.length === emails.length}
            onChange={toggleSelectAll}
          />
          Select All
        </label>
      </div>

      {loading ? (
        <p>Loading emails...</p> // Show loading message
      ) : (
        <ul>
          {emails.length === 0 ? (
            <p>No emails found</p> // Show message if no emails are available
          ) : (
            emails.map(({ email, attributes }) => (
              <li key={email}>
                <input
                  type="checkbox"
                  checked={selectedEmails.includes(email)}
                  onChange={() => toggleSelect(email)}
                />
                <span>{email}</span>
                {attributes?.FIRSTNAME && (
                  <span>
                    {attributes.FIRSTNAME} {attributes.LASTNAME}
                  </span>
                )}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default EmailList;
